export const mediaSizes = ["sm", "md", "lg"] as const;
export type MediaSize = (typeof mediaSizes)[number];
